"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import EditUserPasswordDialog from "@/views/managements/usermanager/components/dialog/EditUserPasswordDialog.vue";
import i18n from "@/lang";
export class AccountChildInfoForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.name = "";
    this.account = "";
    this.password = "1111111111";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("accountchildinfo.please_fill_in_your_name"),
      trigger: "blur"
    }
  ])
], AccountChildInfoForm.prototype, "name", 2);
let UserInfo = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.controller = new AccountChildInfoForm();
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getInfo();
    });
  }
  getInfo() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v5/user/info`);
        this.controller.name = response.data.name;
        this.controller.account = response.data.account;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openEditPassword() {
    return __async(this, null, function* () {
      try {
        this._edit_user_password_dialog.open();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        const response = yield API.put("api://base.auth/api/v5/user/info", {
          username: this.controller.name
        });
        this.$message.success(
          this.$t("accountchildinfo.modified_successfully")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("edit-user-password-dialog")
], UserInfo.prototype, "_edit_user_password_dialog", 2);
UserInfo = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      EditUserPasswordDialog
    }
  })
], UserInfo);
export {
  UserInfo as default
};
